import React from 'react';
import { AwardIcon, ShieldCheckIcon, GlobeIcon, UsersIcon } from 'lucide-react';
const ITEMS = [{
  icon: AwardIcon,
  title: 'FIFA Registered',
  copy: 'Certified head coach'
}, {
  icon: ShieldCheckIcon,
  title: 'UPSL Experience',
  copy: 'Pro league background'
}, {
  icon: GlobeIcon,
  title: 'International',
  copy: 'Played & coached abroad'
}, {
  icon: UsersIcon,
  title: 'Small Groups',
  copy: 'As few as 4 players'
}];
export function TrustBar() {
  return <section className="w-full border-y border-ink-line bg-ink-soft" data-id="element-332" data-mp="1qvk2wqhigvzi">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-8" data-id="element-333" data-mp="1uygf9zggjvv0">
        <ul className="grid grid-cols-2 gap-6 sm:grid-cols-4 sm:divide-x sm:divide-ink-line" data-id="element-334" data-mp="1gzqi6jtn1w6n">
          {ITEMS.map(({
          icon: Icon,
          title,
          copy
        }) => <li key={title} className="flex items-center gap-3 sm:justify-center sm:px-4" data-id="element-335" data-mp="1m0ei5uzuhnd0">
              <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-brand-orange to-brand-red" data-id="element-336" data-mp="5iqrttquprf9">
                <Icon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-337" data-mp="1ai5aq3ngup00" />
              </span>
              <span data-id="element-338" data-mp="16htqut2xgspl">
                <span className="block text-sm font-bold uppercase tracking-wide" data-id="element-339" data-mp="16id807kr7d2k">{title}</span>
                <span className="block text-xs text-white/55" data-id="element-340" data-mp="1ki4i3x85g9ba">{copy}</span>
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}